(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-countdown/assets/javascripts/pix-mix-countdown.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-countdown/assets/javascripts/pix-mix-countdown.js');

'use strict';

const {
  useState
} = React;
const {
  useCountdown
} = svs.components.lbUtils;
const PixmixCountdown = _ref => {
  let {
    to
  } = _ref;
  const [cls, setCls] = useState('');
  const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
  const {
    done,
    isSameDay,
    prettyString
  } = useCountdown(to, {
    onComplete: () => {
      if (!cls) {
        setCls(' pix-mix-countdown-complete');
      }
    }
  });
  const evaluateTitle = () => {
    if (done) {
      return 'Spelen har startat!';
    } else if (isSameDay && !shouldReduceMotion) {
      return 'Spelen startar om:';
    } else if (isSameDay) {
      return 'Spelen startar:';
    }
    return 'Spelstopp:';
  };
  const evaluateValue = () => {
    if (isSameDay && prettyString && !shouldReduceMotion) {
      return prettyString;
    }
    const weekday = to.toLocaleString('sv-SE', {
      weekday: 'long'
    });
    const time = to.toLocaleTimeString('sv-SE', {
      hour: '2-digit',
      minute: '2-digit'
    });
    return "".concat(weekday.charAt(0).toUpperCase() + weekday.slice(1), " ").concat(time);
  };
  return React.createElement("div", {
    className: "pix-mix-countdown".concat(cls)
  }, React.createElement("p", {
    className: "pix-mix-countdown-label",
    "data-testid": "qa-pix-mix-countdown-label"
  }, evaluateTitle()), !done && React.createElement("p", {
    className: "pix-mix-countdown-value",
    "data-testid": "qa-pix-mix-countdown-value",
    role: "timer"
  }, evaluateValue()));
};
setGlobal('svs.pix_mix.components.PixmixCountdown', PixmixCountdown);

 })(window);